import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
    .tcs-program{
        background-image: url("../Banner2-edtech.jpg");
        background-position: center;
        background-repeat  : no-repeat;
        background-size    : cover;
    }
    .hero-image-area {
        background-size    : cover;
        background-position: center;
        background-repeat  : no-repeat;
        position           : relative;
        z-index : 2;


        &::before {
            position  : absolute;
            content   : "";
            background: ${colors.black1};
            opacity   : 0;
            width     : 100%;
            height    : 100%;
            top       : 0;
            left      : 0;
        }

        .round-shape {
            background-position: bottom;
            background-repeat  : no-repeat;
            background-size    : contain;
            position           : absolute;
            bottom             : 0;
            left               : 0;
            width              : 100%;
            height             : 100%;
        }

        .hero-table {
            display : table;
            width   : 100%;
            height  : 100%;
            position: relative;
            z-index : 2;

            .hero-tablecell {
                display       : table-cell;
                vertical-align: middle;

                .hero-box {

                    h1 {
                        font-size    : 46px;
                        color        : #ffffff;
                        max-width    : 700px;
                        margin       : auto;
                        margin-bottom: 20px;
                        font-weight  : 600;

                        @media(max-width: 767px) {
                            font-size: 26px;
                            font-weight: 500;
                            max-width: 100%;
                        }
                    }

                    p {
                        font-size    : 16px;
                        color        : ${colors.border3};
                        max-width    : 600px;
                        line-height  : 30px;
                        margin       : auto;
                        margin-bottom: 60px;

                        @media(max-width: 575px) {
                            font-size : 15px;
                            line-height : 25px;
                        }
                    }

                    .video-player {

                        button.play-button {
                            transform : translateX(0) translateY(-50%);
                            box-sizing: content-box;
                            display   : block;
                            width     : 32px;
                            height    : 44px;
                            margin    : auto;
                            border-radius : 50%;

                            i {
                                position   : relative;
                                font-size  : 40px;
                                color      : #ffffff;
                                z-index    : 11;
                                padding-top: 2px;
                                margin-left: -2px;
                            }

                            &::before {
                                content   : "";
                                position  : absolute;
                                z-index   : 0;
                                left      : 50%;
                                top       : 50%;
                                transform : translateX(-50%) translateY(-50%);
                                display   : block;
                                width     : 70px;
                                height    : 70px;
                                background: ${colors.green};
                                border-radius : 50%;
                                animation: pulse-border 1500ms ease-out infinite;
                            }

                            &:after {
                                content   : "";
                                position  : absolute;
                                z-index   : 1;
                                left      : 50%;
                                top       : 50%;
                                transform : translateX(-50%) translateY(-50%);
                                display   : block;
                                width     : 70px;
                                height    : 70px;
                                background: ${colors.green};
                                border-radius : 50%;
                                transition : all 200ms;
                            }

                            &:hover {
                                i {
                                    color: #ffffff;
                                }
                            }

                            @keyframes pulse-border {
                                0% {
                                    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
                                    opacity  : 1;
                                }

                                100% {
                                    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
                                    opacity  : 0;
                                }
                            }
                        }
                    }
                }
            }
        }

       
    }
    .carousel-item {
        width: 100%; /* or a specific width in pixels */
        /* or a specific height in pixels  height: 200px; */
        object-fit: cover; /* optional: ensures images maintain aspect ratio */
      }
     
      
            .content {
                border: 2px solid black;
                height: 200px; 
                overflow-y: auto; 
                padding: 20px;   
                background: #fff;
                border-radius: 12px;
                }

      .custom-hero-table {
        display : table;
        width   : 100%;
        height  : 100%;
        position: relative;
        z-index : 2;

        .hero-tablecell {
            display       : table-cell;
            vertical-align: middle;

            .hero-box {

                h1 {
                    font-size    : 46px;
                    color        : #ffffff;
                    max-width    : 700px;
                    margin       : auto;
                    margin-bottom: 20px;
                    font-weight  : 600;

                    @media(max-width: 767px) {
                        font-size: 26px;
                        font-weight: 500;
                        max-width: 100%;
                    }
                }

                p {
                    font-size    : 16px;
                    color        : ${colors.border3};
                    max-width    : 600px;
                    line-height  : 30px;
                    margin       : auto;
                    margin-bottom: 60px;

                    @media(max-width: 575px) {
                        font-size : 15px;
                        line-height : 25px;
                    }
                }

                .video-player {

                    button.play-button {
                        transform : translateX(0) translateY(-50%);
                        box-sizing: content-box;
                        display   : block;
                        width     : 32px;
                        height    : 44px;
                        margin    : auto;
                        border-radius : 50%;

                        i {
                            position   : relative;
                            font-size  : 40px;
                            color      : #ffffff;
                            z-index    : 11;
                            padding-top: 2px;
                            margin-left: -2px;
                        }

                        &::before {
                            content   : "";
                            position  : absolute;
                            z-index   : 0;
                            left      : 50%;
                            top       : 50%;
                            transform : translateX(-50%) translateY(-50%);
                            display   : block;
                            width     : 70px;
                            height    : 70px;
                            background: ${colors.green};
                            border-radius : 50%;
                            animation: pulse-border 1500ms ease-out infinite;
                        }

                        &:after {
                            content   : "";
                            position  : absolute;
                            z-index   : 1;
                            left      : 50%;
                            top       : 50%;
                            transform : translateX(-50%) translateY(-50%);
                            display   : block;
                            width     : 70px;
                            height    : 70px;
                            background: ${colors.green};
                            border-radius : 50%;
                            transition : all 200ms;
                        }

                        &:hover {
                            i {
                                color: #ffffff;
                            }
                        }

                        @keyframes pulse-border {
                            0% {
                                transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
                                opacity  : 1;
                            }

                            100% {
                                transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
                                opacity  : 0;
                            }
                        }
                    }
                }
            }
        }
    }

/* From Uiverse.io by mrhyddenn */ 
.uiverse {
  transform: translateY(-110px);
  position: relative;
  background: #ffffff;
  color: #000;
  padding: 15px;
  margin: 10px;
  border-radius: 30px;
  width: 400px;
  height: 50px;
  font-size: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 0px 40px rgba(0, 0, 0, 0.39);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.tooltip {
  position: absolute;
  top: 0;
  font-size: 14px;
  background: #ffffff;
  color: #ffffff;
  padding: 5px 8px;
  border-radius: 5px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.tooltip::before {
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  background: #ffffff;
  bottom: -3px;
  left: 50%;
  transform: translate(-50%) rotate(45deg);
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.uiverse:hover .tooltip {
  top: -45px;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

svg:hover span,
svg:hover .tooltip {
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.1);
}

.uiverse:hover,
.uiverse:hover .tooltip,
.uiverse:hover .tooltip::before {
  background: linear-gradient(320deg, rgb(3, 77, 146), rgb(0, 60, 255));
  color: #ffffff;
}

@media (max-width: 1340px) {
    .carousel-inner {
        img {
            width: 100%;
        }
    }
}

`;
